import { connect } from 'react-redux';
import RootStoreContext from '~/contexts/RootStoreContext';
import { actions as modalActions } from '~/domains/modal';
import { selectors as agentScannersSelectors } from '~/domains/agentScanners';
import AgentScannersView from './AgentScannersView';

const mapStateToProps = (state) => ({
  scanConfigurations: agentScannersSelectors.scanners(state),
  isFetchingScanConfigurations: agentScannersSelectors.isFetchingScanners(state)
});

const mapDispatchToProps = (dispatch) => ({
  openModal: ({ modalType, modalProps }) =>
    dispatch(modalActions.openModal({ modalType, modalProps }))
});

export default connect(mapStateToProps, mapDispatchToProps, null, {
  context: RootStoreContext
})(AgentScannersView);
